// Shared multi-child selection helper for the PlayFirst Parent app.
//
// Before this existed, most PFP pages just used `children[0]` on load which
// meant a parent with two kids would silently see child #1's data on Language
// Map / Settings / My Toys even after picking child #2 on Home. This helper
// centralises the selection so every page respects the same persisted choice.

const STORAGE_KEY = 'parentapp_selected_child_id';

/**
 * Pick the currently-active child from a list.
 * Reads the persisted id first, falls back to the first child, and
 * always re-persists the chosen id so downstream pages stay in sync.
 */
export function pickActiveChild(list) {
  if (!Array.isArray(list) || list.length === 0) return null;
  let selectedId = null;
  try {
    selectedId = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
  } catch {
    /* localStorage disabled — fall through */
  }
  const found = selectedId ? list.find((c) => c && c.id === selectedId) : null;
  const picked = found || list[0];
  try {
    if (picked && picked.id && typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, picked.id);
    }
  } catch {
    /* noop */
  }
  return picked;
}

/**
 * Persist a new active child id. Call this from a switcher's onValueChange.
 */
export function setActiveChildId(id) {
  if (!id) return;
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, id);
    }
  } catch {
    /* noop */
  }
}

export const ACTIVE_CHILD_STORAGE_KEY = STORAGE_KEY;
